export enum PaymentTypeEnum {
  PAYMENT_OUTSIDE_BRAZIL = 'payment_outside_brazil',
  PAYMENT_WITHIN_BRAZIL = 'payment_within_brazil',
  NO_PAYMENT = 'no_payment',
}
